import React from 'react';
import ReactDOM from 'react-dom';
import {Route, Link, BrowserRouter as Router, HashRouter} from 'react-router-dom'
import './css/index.css';
import App from './App';
import CityChoose from './components/CityChoose.js';
import MobilePage from './components/MobilePage.js';
import Verify from './components/Verify.js';
import MainMenu from './components/MainMenu.js';
import * as serviceWorker from './serviceWorker';
import CatShop from "./components/CatShop";
import Shops from "./components/Shops";
import Shop from "./components/Shop";
import Cart from "./components/Cart";
import AddressList from "./components/AddressList";
import Payment from "./components/Payment";
import Reports from "./components/Reports";
import ReportOrderShow from "./components/ReportOrderShow";
import Profile from "./components/Profile";
import Search from "./components/Search";
import Signup from "./components/Signup";
import AddAddress from "./components/AddAddress";
import Divar from "./components/Divar";
import NewProducts from "./components/NewProducts";
import Arzansara from "./components/Arzansara";
import News from "./components/News";
import DeliveryRequest from "./components/DeliveryRequest";
import Services from "./components/Services";
import ServiceShow from "./components/ServiceShow";
import Favorites from "./components/Favorites";
import ProductShow from "./components/ProductShow";
import Credit from "./components/Credit";
import Messages from "./components/Messages";
import Amazing from "./components/Amazing";
import ProductsFromImageClick from "./components/ProductsFromImageClick";
import StoresFromImageClick from "./components/StoresFromImageClick";
import MoreProductOfMenuItems from "./components/MoreProductOfMenuItems";
import MoreStoreOfMenuItems from "./components/MoreStoreOfMenuItems";
import CategoryOfService from "./components/CategoryOfService";

const routing = (
    <HashRouter basename={""}>
        <div>
            <Route exact path="/"><App/></Route>
            <Route path="/city" component={CityChoose} />
            <Route path="/phone" component={MobilePage} />
            <Route path="/verify" component={Verify} />
            <Route path="/signup" component={Signup} />
            <Route path="/home/:from_notification?" component={MainMenu} />
            <Route path="/categories" component={CatShop} />
            <Route path="/stores" component={Shops} />
            <Route path="/store" component={Shop} />
            <Route path="/cart" component={Cart} />
            <Route path="/address" component={AddressList} />
            <Route path="/choose_address" component={AddressList} />
            <Route path="/addAddress" component={AddAddress} />
            <Route path="/payment" component={Payment} />
            <Route path="/reports" component={Reports} />
            <Route path="/order" component={ReportOrderShow} />
            <Route path="/profile" component={Profile} />
            <Route path="/search" component={Search} />
            <Route path="/divar" component={Divar} />
            <Route path="/new_products" component={NewProducts} />
            <Route path="/arzansara" component={Arzansara} />
            <Route path="/news" component={News} />
            <Route path="/delivery" component={DeliveryRequest} />
            <Route path="/services" component={Services} />
            <Route path="/service" component={ServiceShow} />
            <Route path="/favorites" component={Favorites} />
            <Route path="/product" component={ProductShow} />
            <Route path="/add_credit" component={Credit} />
            <Route path="/messages" component={Messages} />
            <Route path="/amazing" component={Amazing} />
            <Route path="/products" component={ProductsFromImageClick} />
            <Route path="/stores_show" component={StoresFromImageClick} />
            <Route path="/moreProducts" component={MoreProductOfMenuItems} />
            <Route path="/moreStores" component={MoreStoreOfMenuItems} />
            <Route path="/categories_of_services" component={CategoryOfService} />
        </div>
    </HashRouter>
);
ReactDOM.render(
    <React.StrictMode>
        {routing}
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https:/bit.ly/CRA-PWA
serviceWorker.register();
